module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_c('span', [_vm._v("设备详情")]), _vm._v(" "), _c('el-button', {
    staticClass: "back",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "detail-title"
  }, [_vm._v("设备状态")]), _vm._v(" "), _c('DeviceStatus', {
    attrs: {
      "uid": _vm.deviceUid
    }
  })], 1), _vm._v(" "), (_vm.settingInfo.masterDeviceSwitch) ? _c('div', {
    staticClass: "detail-record"
  }, [_c('span', [_vm._v("最近一次人脸库导出记录：\n         " + _vm._s(_vm.faceExportInfo.exportTime ? _vm.$util.dateFormat(_vm.faceExportInfo.exportTime, 'yyyy-MM-dd HH:mm:ss') : '') + "\n      ")]), _vm._v(" "), (_vm.faceExportInfo.status == 1) ? _c('span', {
    staticClass: "record-success"
  }, [_vm._v("导出成功")]) : _vm._e(), _vm._v(" "), (_vm.faceExportInfo.status == 0) ? _c('span', {
    staticClass: "record-failure"
  }, [_vm._v("导出失败")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "detail-title title-margin"
  }, [_vm._v("智慧体育盒子")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.upgradeList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "当前版本",
      "prop": "versionCode"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "更新日期",
      "prop": "updateTime"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "最近配置的更新",
      "prop": "lastVersionCode"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.clickUpdate(row)
            }
          }
        }, [_vm._v("更新")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "detail-title title-margin"
  }, [_vm._v("外接设备")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.externalList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序号",
      "width": "80",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "类型",
      "prop": "deviceType"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "名称",
      "prop": "deviceName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "IP地址",
      "prop": "ipAddress"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "设备密码",
      "prop": "devicePassword"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "当前版本",
      "prop": "versionCode"
    }
  }), _vm._v(" "), (_vm.settingInfo.masterDeviceSwitch) ? _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "主控机器"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(_vm.handleMainControlState(row)))]), _vm._v(" "), _c('el-button', {
          staticClass: "margin-left-10",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.clickEditMainControl(row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }], null, false, 2185116962)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "更新日期",
      "prop": "updateTime"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "外接IPC"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.clickExternalIPC(row)
            }
          }
        }, [_vm._v("\n                  " + _vm._s(row.ipcNumber || 0) + "台\n               ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleExternalUpdate(row)
            }
          }
        }, [_vm._v("更新")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "设备更新",
      "destroy-on-close": "",
      "close-on-click-modal": false,
      "modal-append-to-body": false
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.updateDialog.visible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.clickUpdateDone
          }
        }, [_vm._v("确认")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.updateDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.updateDialog, "visible", $$v)
      },
      expression: "updateDialog.visible"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择固件版本:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择固件版本",
      "filterable": ""
    },
    model: {
      value: (_vm.updateDialog.selectId),
      callback: function($$v) {
        _vm.$set(_vm.updateDialog, "selectId", $$v)
      },
      expression: "updateDialog.selectId"
    }
  }, _vm._l((_vm.updateDialog.data), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "版本描述内容:"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.updateDialog.content[_vm.updateDialog.selectId]))])])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "是否设置当前机器为主控",
      "size": "tiny",
      "close-on-click-modal": false,
      "modal-append-to-body": false,
      "destroy-on-close": "",
      "center": ""
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('div', {
          staticClass: "flex-row-center"
        }, [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.mainControlDialog.visible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.clickEditMainControlDone
          }
        }, [_vm._v("保存")])], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.mainControlDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.mainControlDialog, "visible", $$v)
      },
      expression: "mainControlDialog.visible"
    }
  }, [_c('div', {
    staticClass: "flex-row-center"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.mainControlDialog.isMainControl),
      callback: function($$v) {
        _vm.$set(_vm.mainControlDialog, "isMainControl", $$v)
      },
      expression: "mainControlDialog.isMainControl"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row-center margin-top-20"
  }, [_vm._v("修改并保存成功，会同步到一体机")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-183ad5b8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UniversityManage/EquipmentManage/EquipmentList/EquipmentBoxVenue/EquipmentBoxVenueDetail.vue
// module id = 955
// module chunks = 0